import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { toast } from 'react-toastify'

interface CalComProps {
    calComBookingUrl: string;
    createIntegration: any;
    modalVisible: boolean;
    setModalVisible: any;
}

export default function CalCom({ calComBookingUrl, createIntegration, modalVisible, setModalVisible }: CalComProps) {
    const [calComUrl, setCalComUrl] = useState(calComBookingUrl ? calComBookingUrl : '');

    function validateCalComUrl(url: string): boolean {
        try {
            const parsedUrl = new URL(url);
            const hostname = parsedUrl.hostname.toLowerCase();
            const hasCalComHost = hostname === 'cal.com' || hostname.endsWith('.cal.com');
            const hasBookingPath = parsedUrl.pathname.trim() !== '' && parsedUrl.pathname !== '/';

            return parsedUrl.protocol === 'https:' && hasCalComHost && hasBookingPath;
        } catch {
            return false;
        }
    }

    function createCalComIntegration() {
        const trimmedUrl = calComUrl.trim();
        if (!validateCalComUrl(trimmedUrl)) {
            toast.error('Please enter a valid Cal.com booking URL (e.g., https://cal.com/username/event-type or https://abacus.cal.com/go/abacus-demo)');
            return;
        }
        createIntegration({
            calComUrl: trimmedUrl,
            appName: 'cal-com'
        });
    }

    return (
        <Dialog open={modalVisible} onOpenChange={setModalVisible}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Connect Cal.com</DialogTitle>
                    <DialogDescription>
                        Enter a booking URL for the meeting type you want. You can connect more than one and assign each to a different skill.
                    </DialogDescription>
                </DialogHeader>

                <div className="grid gap-4 py-4">
                    <Input
                        value={calComUrl}
                        onChange={(e) => setCalComUrl(e.target.value)}
                        placeholder="https://abacus.cal.com/go/abacus-demo"
                        className={!validateCalComUrl(calComUrl) && calComUrl ? 'border-red-500' : ''}
                    />
                </div>

                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => setModalVisible(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={createCalComIntegration}
                    >
                        Connect
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
